import React, { useEffect, useRef, useState } from 'react'
import useStyles from '../styles'

interface CopyButtonProps {
  value: string
  label?: string
}

const CopyButton: React.FC<CopyButtonProps> = ({ value, label = 'Copy' }) => {
  const classes = useStyles()
  const [copied, setCopied] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(
    () => () => {
      if (timeoutRef.current !== null) clearTimeout(timeoutRef.current)
    },
    [],
  )

  const handleCopy = (e: React.MouseEvent): void => {
    e.stopPropagation()
    void navigator.clipboard
      .writeText(value)
      .then(() => {
        setCopied(true)
        if (timeoutRef.current !== null) clearTimeout(timeoutRef.current)
        timeoutRef.current = setTimeout(() => setCopied(false), 1200)
      })
      .catch(() => {
        // Clipboard can be blocked (permissions / insecure origin); ignore.
      })
  }

  return (
    <button
      type='button'
      className={classes.copyButton}
      onClick={handleCopy}
      aria-label={label}
      title={copied ? 'Copied!' : label}
    >
      <span
        className='material-symbols-outlined'
        style={{ fontSize: 14 }}
      >
        {copied ? 'check' : 'content_copy'}
      </span>
    </button>
  )
}

export default CopyButton
